module.exports = __webpack_public_path__ + "static/placa-prematuridade-74b49e61b4ca914d89bda0629face82a.png";